import Axios from "../api/axios";
import config from "../../config";

const getPrompts = () => {
  return Axios.get(`${config.BASE_URL}prompt`);
};

export default getPrompts;
